import {Box, Grid, TextField, Typography} from "@material-ui/core";
import cash from "../../assets/images/cash-on-delivery.svg";
import Dialog from "@material-ui/core/Dialog";
import * as React from "react";
import {useState} from "react";

const GroupInstallmentPayment = ({openDialog, handleClose, handleClickOpen}) => {
    const [requestID, setRequestID] = useState()
    const [fullName, setFullName] = useState()
    const [nationalCode, setNationalCode] = useState()
    const [phoneNumber, setPhoneNumber] = useState()
    const [savingsCode, setSavingsCode] = useState()
    const [savingsInventory, setSavingsInventory] = useState()
    const [groupName, setGroupName] = useState()
    const [groupInventory, setGroupInventory] = useState()
    const [loanNumber, setLoanNumber] = useState()
    const [loanAmount, setLoanAmount] = useState()
    const [installmentsNumber, setInstallmentsNumber] = useState()
    const [waitingTime, setWaitingTime] = useState()
    const [paymentStatus, setPaymentStatus] = useState()
    const [initialAmount, setInitialAmount] = useState()
    const [dateRequest, setDateRequest] = useState()
    const [status, setStatus] = useState()
    //
    const [id, setId] = useState("1")
    const [installmentNumber, setInstallmentNumber] = useState("12000542")
    const [dueDate,setDueDate]=useState("1400/12/12")
    const [amount,setAmount]=useState("85000")
    return (

        <Dialog fullScreen onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
                id="customized-full-screen-dialog">
            <section className="pageContainer">
                <Box className="transactionHeader">
                    <section className="transactionTitle">
                        <Grid xs={12} sm={12} md={6} lg={6} xl={6}
                              className="d-flex flex-column flex-nowrap justifyContentCenter">
                            <Typography variant={"h6"}>
                                جزئیات در خواست وام
                            </Typography>
                        </Grid>
                        <Grid xs={12} sm={12} md={6} lg={6} xl={6} className="loan-details-button-group">
                            <Grid>
                                <button className="btn-secondary me-2 " onClick={handleClose}>
                                    بازگشت
                                </button>
                            </Grid>
                            <Grid>
                                <button className="btn-confirm">
                                    تغییر وضعیت وام
                                </button>
                            </Grid>
                        </Grid>
                    </section>
                </Box>
                <Box className="loan-details-main-box">
                    <Box className="w-100" sm={12}>
                        <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12}
                              style={{marginTop: '1rem'}}>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="شناسه درخواست"
                                           value={requestID}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true}
                                           label="نام و نام خانوادگی"
                                           value={fullName}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="کد ملی"
                                           value={nationalCode}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="شماره همراه"
                                           value={phoneNumber}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="کد پس انداز"
                                           value={savingsCode}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="موجودی پس انداز"
                                           value={savingsInventory}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="نام گروه"
                                           value={groupName}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="موجودی گروه"
                                           value={groupInventory}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="تعداد وام ها"
                                           value={loanNumber}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="مبلغ وام (ریال)"
                                           value={loanAmount}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="تعداد اقساط"
                                           value={installmentsNumber}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true}
                                           label="زمان انتظار برای وام"
                                           value={waitingTime}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="وضعیت نوع پرداخت"
                                           value={paymentStatus}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true}
                                           label="مبلغ پرداخت اولیه(ریال)"
                                           value={initialAmount}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="تاریخ درخواست"
                                           value={dateRequest}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="وضعیت"
                                           value={status}/>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className="BorderBox">
                        <Box className="d-flex flex-column">
                          <span className="titleOfOBorderBox">
                        اقساط وام
                    </span>
                            {/*{itemCount > 0 ?*/}
                            {/*    <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>*/}
                            {/*        {" " + itemCount + " قسط"}*/}
                            {/*    </Typography> :*/}
                            {/*    ''}*/}

                        </Box>

                        <img src={cash} alt=""/>
                    </Box>
                    <Box className="d-flex flex-column">
                        {
                            [...Array(10)].map(_ => {
                                return <Box className="cardCustom">
                                    <Grid xs={6} sm={4} md={4} lg={1} xl={3} className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">#</span>
                                        <span className="cardCustomDescription">{id}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={4} lg={2} xl={3} className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">شماره قسط</span>
                                        <span className="cardCustomDescription">{installmentNumber}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={4} lg={2} xl={3} className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">تاریخ سر رسید</span>
                                        <span className="cardCustomDescription">{dueDate}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={4} lg={2} xl={3} className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">مبلغ(ریال)</span>
                                        <span className="cardCustomDescription">{amount}</span>
                                    </Grid>
                                </Box>
                            })
                        }

                    </Box>
                </Box>


            </section>


        </Dialog>
    )
}
export default GroupInstallmentPayment